import React from "react";

import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import {
  IconButton,
  Slider,
  Stack,
  Typography,
  useTheme,
  Tooltip,
} from "@mui/material";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  layerDefOpacitySelector,
  layerDefVisibilitySelector,
} from "../map/layerAtoms";

const MAX_OPACITY = 1;
const MIN_OPACITY = 0;

export default function TransparencySlider({ layerID }) {
  const [opacity, setOpacity] = useRecoilState(
    layerDefOpacitySelector(layerID)
  );

  const layerVisible = useRecoilValue(layerDefVisibilitySelector(layerID));

  const theme = useTheme();
  if (typeof opacity !== "number") {
    return null;
  }
  const step = (MAX_OPACITY - MIN_OPACITY) / 10;
  const buttonStep = step;
  const increaseSlider = () => {
    if (opacity === MAX_OPACITY) {
      return;
    }
    if (roundedAddition(opacity, buttonStep) > MAX_OPACITY) {
      setOpacity(MAX_OPACITY);
      return;
    }
    setOpacity((currentOpacity) => roundedAddition(currentOpacity, buttonStep));
  };

  const decreaseSlider = () => {
    if (opacity === MIN_OPACITY) {
      return;
    }
    if (roundedSubtraction(opacity, buttonStep) < MIN_OPACITY) {
      setOpacity(MIN_OPACITY);
      return;
    }
    setOpacity((currentOffset) =>
      roundedSubtraction(currentOffset, buttonStep)
    );
  };
  return (
    <Tooltip title={layerVisible ? "" : "Layer Turned Off"}>
      <Stack
        spacing={2}
        direction="row"
        sx={{
          mb: 1,
          ml: 3,
          width: "350px",
          maxWidth: `calc(100% - ${theme.spacing(4)})`,
        }}
        alignItems="center"
      >
        <Typography variant="caption" id="input-slider">
          Transparency:
        </Typography>
        <IconButton
          aria-label="Decrease layer opacity"
          onClick={decreaseSlider}
          disabled={!layerVisible || opacity === MIN_OPACITY}
          color="primary"
        >
          <RemoveCircleIcon />
        </IconButton>
        <Slider
          disabled={!layerVisible}
          size="small"
          value={opacity}
          aria-label="Transparency"
          max={MAX_OPACITY}
          min={MIN_OPACITY}
          step={step}
          onChange={(event) => {
            setOpacity(event.target.value);
          }}
          marks
        />
        <IconButton
          aria-label="Increase layer opacity"
          onClick={increaseSlider}
          disabled={!layerVisible || opacity === MAX_OPACITY}
          color="primary"
        >
          <AddCircleIcon />
        </IconButton>
      </Stack>
    </Tooltip>
  );
}

const roundedAddition = (value1, value2) => {
  const result = value1 + value2;
  return Math.round(result * 10) / 10;
};

const roundedSubtraction = (value1, value2) => {
  const result = value1 - value2;
  return Math.round(result * 10) / 10;
};
